import { render, staticRenderFns } from "./extension-status.vue?vue&type=template&id=657cc4e4&"
import script from "./extension-status.vue?vue&type=script&lang=js&"
export * from "./extension-status.vue?vue&type=script&lang=js&"
import style0 from "./extension-status.vue?vue&type=style&index=0&id=657cc4e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports